<!--
 * @Author: yubaolee <yubaolee@163.com> | ahfu~ <954478625@qq.com>
 * @Date: 2021-06-01 14:10:29
 * @LastEditTime: 2022-12-15 21:33:25
 * @Description: 一级菜单项
 * @
 * @Copyright (c) 2022 by yubaolee | ahfu~ , All Rights Reserved. 
-->
<template>
  <div v-if="!item.hidden">
    
    <div class="menudd">
      <!-- 只有一级，没有子菜单的导航，比如系统自带的【接口文档】导航 -->
      <template v-if="!item.children || item.children.length <= 0 || item.alwaysShow">
        <el-menu-item :index="item.path" :class="{ 'submenu-title-noDropdown': !isNest }">
          <i :class="`iconfont icon-${item.meta.icon}`" style="margin-right: 10px;"></i>
          <span v-if="item.meta && item.meta.title" slot="title" class="stycls">{{
            item.meta.title 
          }}</span>
        </el-menu-item>
        
      </template>

      <!-- 有子菜单的导航 -->
      <el-submenu v-else :index="item.path">
        <!-- 有子菜单的顶级显示项，如【基础配置】导航 -->

        <template slot="title">
          <i :class="`iconfont icon-${item.meta.icon}`" style="margin-right: 10px;"></i>
          <span v-if="item.meta && item.meta.title" slot="title" class="stycls">{{
            item.meta.title
          }}</span>
        </template>
        <div class="wbf">
          <template v-for="child in routes">
            <template v-if="!child.hidden">
              <!-- 如果子菜单还有子节点，递归处理 -->
              <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children && child.children.length > 0"
                :item="child" :key="child.meta.id"></sidebar-item>
              <!-- 具体的导航菜单 -->
              <el-menu-item v-else :key="child.meta.id" :index="child.path">
                <i :class="`iconfont icon-${child.meta.icon}`" style="margin-right: 4px"></i>
                <span v-if="child.meta && child.meta.title" slot="title" class="stycls1">{{
                  child.meta.title
                }}</span>
              </el-menu-item>

            </template>
          </template>
        </div>

      </el-submenu>
      
    </div>

  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    // route配置json
    item: {
      type: Object,
      required: true,
    },
    isNest: {
      type: Boolean,
      default: false,
    },
    basePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      routes: [],
    }
  },
  watch: {
    item() {
      this.groupRouters()
    },
  },
  created() {
    this.groupRouters()
  },
  methods: {
    groupRouters() {
      //console.log(this)
      this.routes =
        this.item.children &&
        this.item.children.length > 0 &&
        this.item.children.sort((a, b) => a.meta.sortNo - b.meta.sortNo)
    },

    clickRoute(e) {
      console.log(e)
    }
  },
}
</script>
<style lang="scss">
.el-menu-item {
  background-color: var(--background-color) !important;
}


.trueD .el-menu {
  overflow-y: auto;
  height: 200px !important;
}

//font-family: Monaco, Menlo, Consolas, "Courier New", monospace;
.stycls {

  font-size: 16px;
  // font-weight: 500;
  // color: #272a34;
}

.stycls1 {
  font-size: 14px;
  font-weight: 500;
  // color: #272a34;
}

.wbf {
  overflow-y: scroll;
  max-height: calc(100vh - 55px);
  margin: -6px;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none !important;
  }
}
</style>
